/**
 * @generated SignedSource<<5fbbdddee9094a66e8d5286703744cc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Session__PasswordResetConfirmPayload",
    "kind": "LinkedField",
    "name": "passwordResetConfirm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordResetConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordResetConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00f86653934c3ba61be3f80ff9e2753e",
    "id": null,
    "metadata": {},
    "name": "PasswordResetConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordResetConfirmMutation(\n  $input: Session__PasswordResetConfirmInput!\n) {\n  passwordResetConfirm(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

node.hash = "b7e85671cc7edc847e050a76eb790f08";

module.exports = node;
